var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLockOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M10 0a4.5 4.5 0 0 1 4.495 4.288l.005.212-.001 2.5H16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.5l1.999-.001L7.5 4.5l-1.993-.25A4.5 4.5 0 0 1 10 0m5.5 9h-11a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5M10 2a2.5 2.5 0 0 0-2.495 2.336L7.5 4.5V7l-.001-.001V7h5l.001-2.5a2.5 2.5 0 0 0-2.336-2.495z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 13.5,
  r: 1.5
}))));
export default SvgIconLockOpen;